export default __webpack_public_path__ + "static/media/onHandRed.0dea5f77.svg";